import { jsx, jsxs } from 'react/jsx-runtime';
import { isNil } from 'lodash';
import { formatDate, useMask } from '@ninja/utilities';

function FormNonEditableField(props) {
    var _a;
    const { schema, fieldValue } = props;
    const { type, onRenderNoneEditable } = schema;
    let value;
    let dir = undefined;
    if (type === 'drop-down') {
        const { options, labelKey, valueKey } = schema;
        value = (_a = options === null || options === void 0 ? void 0 : options.find((opt) => opt[valueKey] === fieldValue)) === null || _a === void 0 ? void 0 : _a[labelKey !== null && labelKey !== void 0 ? labelKey : valueKey];
    }
    else if (type === 'date-picker') {
        value = formatDate(fieldValue);
    }
    else if (type === 'text') {
        const { mask, directionForInput, suffix } = schema;
        if (!isNil(fieldValue)) {
            value = `${fieldValue}`;
        }
        dir = directionForInput;
        const { applyMask } = useMask({ mask });
        if (mask && value) {
            value = applyMask(value).result;
        }
        if (suffix && value) {
            value = `${suffix} ${value}`;
        }
    }
    else if (!isNil(fieldValue)) {
        value = `${fieldValue}`;
    }
    if (isNil(value) || value === '') {
        value = jsx("div", { className: "w-10 mt-2 border-t border-solid border-gray-300" });
    }
    return (jsxs("div", { className: "flex flex-col items-start gap-1 p-0", children: [jsx("div", { className: "font-normal text-caption1 text-gray-700", children: schema.label }), jsx("div", Object.assign({ className: "font-medium text-paragraph" }, (dir ? { dir } : {}), { children: onRenderNoneEditable ? onRenderNoneEditable({ value }) : value }))] }));
}

export { FormNonEditableField as default };
